import React from "react";

export const VarContext = React.createContext();
